import useMarket from 'hooks/useMarket';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Column, Row, Button } from 'components/pages/market/home/MarketItem';
import { SectionTitle } from 'components/pages/market/detail/MarketInfoTabView';
import MarketVertItem from 'components/pages/market/detail/MarketVertItem';
import { Text } from 'components/pages/market/home/MarketHome';

function MarketSuggestions({ info, parentRef }) {
   const NO_DATA_TEXT =
      "유사한 품목을 취급하는 도매상이 없어요\n'향기꽃나라'에서 구매해 보는 건 어떨까요?";
   const SCROLL_TO_TOP_TEXT = '맨 위로 가기';

   const { similarMarkets, fetchSimilarMarkets } = useMarket();
   const scrollToTop = () => {
      if (!parentRef.current) return;
      parentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
   };

   useEffect(() => {
      if (!info) return;
      fetchSimilarMarkets({ wholeId: info.whole_id });
   }, []);

   return (
      <MarketSuggestionsWrap>
         <SectionTitle>{`'${info.whole_name}'와 유사한 도매상`}</SectionTitle>
         {!similarMarkets || similarMarkets?.length <= 0 ? (
            <EmptyDataView>
               <Text>{NO_DATA_TEXT}</Text>
               <Button onClick={scrollToTop}>{SCROLL_TO_TOP_TEXT}</Button>
            </EmptyDataView>
         ) : (
            <HorizListView>
               {similarMarkets.map((item, index) => {
                  return <MarketVertItem key={item.whole_id} item={item} />;
               })}
            </HorizListView>
         )}
      </MarketSuggestionsWrap>
   );
}

export default MarketSuggestions;

const MarketSuggestionsWrap = styled(Column)`
   margin-top: 8px;
   padding: 24px 16px 0px 16px;
   background-color: ${theme.color.white}; ;
`;

const HorizListView = styled(Row)`
   overflow-x: scroll;
   height: 100%;
   gap: 8px;
   -ms-overflow-style: none;
   scrollbar-width: none;
   padding-bottom: 24px;
   &::-webkit-scrollbar {
      display: none;
   }
`;

const EmptyDataView = styled(Column)`
   background: ${theme.color.white};
   border: 1px solid ${theme.color.gray100};
   border-radius: 8px;
   box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.05);
   justify-content: center;
   align-items: center;
   padding: 40px 0px 46px 0px;
   margin-bottom: 24px;

   ${Text} {
      color: ${theme.color.gray700};
      text-align: center;
      margin-bottom: 10px;
      white-space: pre-wrap;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
   }

   ${Button} {
      cursor: pointer;
      width: 240px;
      padding: 12px;
      border: none;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: ${theme.color.white};
      background: ${theme.color.orange};
      border-radius: 8px;
   }
`;
